export default {
    smallScreen() {
        return window.innerWidth < 701
    },
}
